import React from 'react';
import LinkButton from '../../../../utils/LinkButton';

const features = [
  {
    title: 'Flexible installment options to suit your needs',
    icon: '/images/installment.svg',
  },
  {
    title: 'Pay a small upfront amount to get started',
    icon: '/images/upfront.svg',
  },
  {
    title: 'Access a wide selection of quality products',
    icon: '/images/badge.svg',
  },
  { title: 'Vetted vendors', icon: '/images/shield.svg' },
];

export const AboutSection = () => {
  return (
    <section className="py-10 px-4 md:px-10 lg:px-16 flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-6xl mx-auto">
      {/* Left: Image card */}
      <div className="w-full lg:w-[45%] flex-shrink-0">
        <div className="bg-[#FFE600] rounded-2xl flex-col  justify-center items-center  flex ">
          {/* Search bar overlay */}
          <img
            src="/images/shopping-search.min.svg"
            alt="Shopping and housing needs"
            className="block"
          />

          {/* Shopper image */}
          <img
            src="/images/ss-shopper.min.svg"
            alt="SmallSmall shopper"
            className=""
          />
        </div>
      </div>

      {/* Right: Content */}
      <div className="w-full lg:w-[55%]">
        <h2 className="text-2xl text-center md:text-start lg:text-[25px] font-bold mb-1">
          Why Smallsmall?
        </h2>
        <p className="text-gray-600 text-center md:text-start text-base mb-6 leading-relaxed">
          We believe that when you meet your housing and household needs, you
          live better and happier. SmallSmall gives you flexible ways to meet
          those needs today.
        </p>

        <div className="mb-8 hidden md:block">
          <LinkButton link="/how-it-works">Learn more</LinkButton>
        </div>

        <ul className="space-y-4">
          {features.map((item, index) => (
            <li key={index} className="flex items-center gap-4">
              <div className="w-10 h-10  flex items-center justify-center bg-[#F5F5F7] rounded-lg flex-shrink-0">
                <img src={item.icon} alt={item.title} className="w-5 h-5" />
              </div>
              <p className="text-sm text-gray-700">{item.title}</p>
            </li>
          ))}
        </ul>

        <div className="my-8 text-center md:hidden block">
          <LinkButton link="/how-it-works">Learn more</LinkButton>
        </div>
      </div>
    </section>
  );
};
